/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import YouTube from 'react-youtube';
import moment from 'moment';

const ExtensionPlayYoutubeVideo = ({ extensionDetails }) => {
  const localUser = useSelector(state => state.conf.localUser);
  const playYoutubeDetails = useSelector(state => state.conf.playYoutubeDetails);
  const screenDimension = useSelector(state => state.conf.screenDimension);
  const isDragging = useSelector(state => state.conf.isDraging);
  const isToolbarVisible = useSelector(state => state.conf.isToolbarVisible);


  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const playerRef = useRef(null);
  const isRemoteActionRef = useRef(false);

  const isOwner = localUser?.role !== 'guest';
  const videoLink = extensionDetails?.url;
  const autoHideToolbar = localUser?.auto_hide_toolbar || false;


  const videoId = videoLink.includes('watch?v=')
    ? videoLink.split('watch?v=')[1].split('&')[0]
    : videoLink;

  useEffect(() => {
    if (extensionDetails?.id) setIsVideoPlaying(false);
  }, [extensionDetails?.id]);

  /* ---------------- REMOTE LISTENERS ---------------- */
  useEffect(() => {
    if (!playerRef.current || !isVideoPlaying || playYoutubeDetails.userJid === localUser.jid) return;
    if (playYoutubeDetails.eventType === 'audio_update') return;

    const player = playerRef.current;
    isRemoteActionRef.current = true;

    const targetTime = Number(playYoutubeDetails.currentTime);
    if (Math.abs(targetTime - player.getCurrentTime()) > 2) {
      player.seekTo(targetTime, true);
    }

    if (playYoutubeDetails.isPlaying && player.getPlayerState() !== 1) {
      player.playVideo();
    } else if (!playYoutubeDetails.isPlaying && player.getPlayerState() !== 2) {
      player.pauseVideo();
    }

    setTimeout(() => { isRemoteActionRef.current = false; }, 800);
  }, [playYoutubeDetails.isPlaying, playYoutubeDetails.currentTime]);

  //SYNC AUDIO (MUTE & VOLUME)
  useEffect(() => {
    if (!playerRef.current || !isVideoPlaying || playYoutubeDetails.userJid === localUser.jid) return;

    const player = playerRef.current;
    if (typeof playYoutubeDetails.isMuted === 'boolean') {
      playYoutubeDetails.isMuted ? player.mute() : player.unMute();
    }
    if (typeof playYoutubeDetails.volume === 'number') {
      player.setVolume(playYoutubeDetails.volume);
    }
  }, [playYoutubeDetails.isMuted, playYoutubeDetails.volume]);

  /* ---------------- PLAYER INITIALIZATION ---------------- */
  const onPlayerReady = (event) => {
    playerRef.current = event.target;
    setIsVideoPlaying(true);
    if (!playYoutubeDetails) return;

    const player = playerRef.current;
    const nowUTC = moment().utc().valueOf();
    const startTimeMs = moment(playYoutubeDetails?.startTime).valueOf();
    let seekSeconds = 0;

    if (playYoutubeDetails.isPlaying && startTimeMs) {
      const baseTime = Number(playYoutubeDetails?.duration || 0);
      const value = baseTime + (nowUTC - startTimeMs) / 1000;
      seekSeconds = value;
      player?.seekTo(Number(seekSeconds + 1), true);
    }
    if (!playYoutubeDetails.isPlaying && typeof playYoutubeDetails.currentTime === 'number') {
      seekSeconds = playYoutubeDetails.currentTime;
      player.seekTo(seekSeconds, true);
    }

    playYoutubeDetails.isPlaying ? setTimeout(() => player.playVideo(), 2000) : player.pauseVideo();
  };


  const getHeaderHeight = () => {
    const headerHeight = document.querySelector('.navbar').offsetHeight;
    return headerHeight;
  };

  let screenHeight = autoHideToolbar && !isToolbarVisible ? `${screenDimension?.screenHeight + getHeaderHeight()}px` :  `${screenDimension?.screenHeight}px`;
  let caption = autoHideToolbar && isToolbarVisible  ? `${screenDimension?.screenHeight}px` : screenHeight;

  const opts = {
    width: '100%',
    height: caption,
    playerVars: { origin: window.location.origin, autoplay: 0, controls: isOwner ? 1 : 0, rel: 0, fs: 0 },
  };

  return (
    <div style={{ pointerEvents: isDragging ? 'none' : 'auto', height: '100%' }}>
      <YouTube
        videoId={videoId}
        opts={opts}
        className='h-100'
        onReady={onPlayerReady}
      />
    </div>
  );
};

export default ExtensionPlayYoutubeVideo;